import {bufferTime, catchError, distinct, filter, first, groupBy, map, mapTo, mergeMap, tap} from "rxjs/operators";
import {of} from 'rxjs';
import {networkError} from "../actions/ui";
import {combineEpics, ofType} from "redux-observable";
import {
  API_GET_SUBMITTAL,
  API_GET_SUBMITTAL_DONE,
  API_GET_SUBMITTALS,
  API_GET_SUBMITTALS_DONE,
  getSubmittalDone,
  getSubmittals,
  getSubmittalsDone
} from "../actions/submittals";
import * as R from 'ramda';
import {getSubmittals$, getSubmittalsMulti$} from "../services/projects";
import {
  catchErrorsandResume,
  INDIVIDUAL_ID_BUFFER_MS,
  INDIVIDUAL_ID_FETCH_SIZE,
  MODEL_INSERTION_BUFFER_INTERVAL_MS,
  requestDedupInterval$
} from "./index";
import {injectSubview, setSubview, setSubviewCache} from "../actions/view";

const SVCLF = setSubviewCache({ loading: false });

const beginLoading = action$ => action$.pipe(
  ofType(API_GET_SUBMITTAL),
  bufferTime(INDIVIDUAL_ID_BUFFER_MS, null, INDIVIDUAL_ID_FETCH_SIZE),
  filter(actions => actions.length > 0),
  first(),
  mapTo(setSubviewCache({ loading: true })),
  catchErrorsandResume(20058)
);

const endLoading = action$ => action$.pipe(
  ofType(API_GET_SUBMITTAL_DONE, API_GET_SUBMITTALS_DONE),
  bufferTime(INDIVIDUAL_ID_BUFFER_MS, null, INDIVIDUAL_ID_FETCH_SIZE),
  filter(actions => actions.length > 0),
  first(),
  mapTo(setSubviewCache({ loading: false })),
  catchErrorsandResume(20059)
);

const getSingleEpic = action$ => action$.pipe(
  ofType(API_GET_SUBMITTAL),
  mergeMap(action => getSubmittals$({ id: action.payload.id, projectId: action.payload.projectId }).pipe(
    map(({ response }) => getSubmittalDone(response)),
    catchError(error => of(SVCLF, networkError({ ...error, number: '10099-' + error.status })))
  )),
  catchErrorsandResume(20062)
);

const getSingleEpicMulti = action$ => action$.pipe(
  ofType(API_GET_SUBMITTAL),
  groupBy(action => action.payload.projectId),
  mergeMap(group$ => group$.pipe(
    distinct(action => action.payload.id, requestDedupInterval$),
    bufferTime(INDIVIDUAL_ID_BUFFER_MS, null, INDIVIDUAL_ID_FETCH_SIZE),
    filter(actions => actions.length > 0),
    mergeMap(actions => getSubmittalsMulti$({ projectId: actions[0].payload.projectId, ids: actions.map(action => action.payload.id) }).pipe(
      filter(({ response }) => response && response['results']),
      map(({ response }) => setSubview(response.results)),
      catchError(error => of(SVCLF, networkError({ ...error, number: '10100-' + error.status }))),
    )),
    catchError(error => of(SVCLF, networkError({ ...error, number: '10101-' + error.status }))),
  )),
  catchErrorsandResume(20063)
);

const processSingleEpic = action$ => action$.pipe(
  ofType(API_GET_SUBMITTAL_DONE),
  map(action => action.payload),
  bufferTime(MODEL_INSERTION_BUFFER_INTERVAL_MS),
  filter(results => results.length > 0),
  tap(submittals => submittals[0].callback && submittals[0].callback(submittals[0].response.resource.id)),
  map(results => results.map(submittal => submittal.response)),
  map(results => setSubview(results)),
  catchErrorsandResume(20065)
);

const getMultipleEpic = action$ => action$.pipe(
  ofType(API_GET_SUBMITTALS),
  mergeMap(action => getSubmittals$({ projectId: action.payload.projectId, offset: action.payload.offset }).pipe(
    map(({ response }) => getSubmittalsDone(response)),
    catchError(error => of(SVCLF, networkError({ ...error, number: '10102-' + error.status })))
  )),
  catchErrorsandResume(20061)
);

const processMultipleEpic = action$ => action$.pipe(
  ofType(API_GET_SUBMITTALS_DONE),
  filter(action => action.payload && action.payload.results),
  map(action => action.payload.results),
  bufferTime(MODEL_INSERTION_BUFFER_INTERVAL_MS),
  map(results => R.unnest(results)),
  filter(results => results.length > 0),
  map(results => injectSubview(results)),
  catchErrorsandResume(20064)
);

const getMoreEpic = action$ => action$.pipe(
  ofType(API_GET_SUBMITTALS_DONE),
  filter(action => action.payload && action.payload.results && action.payload.results.length === action.payload.limit),
  map(action => getSubmittals(action.payload.results.slice(-1)[0].resource.projectid, action.payload.results.slice(-1)[0].resource.id)),
  catchErrorsandResume(20060)
);

export const submittalsEpic = combineEpics(
  beginLoading,
  endLoading,
  // getSingleEpic,
  getSingleEpicMulti,
  processSingleEpic,
  getMultipleEpic,
  processMultipleEpic,
  getMoreEpic
);



// WEBPACK FOOTER //
// ./src/network/submittals.js